<script>
export default {
    name: 'FlagItaly'
}
</script>
<template>
    <svg
        class="base-flag flag-italy"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        width="28"
        height="20"
        viewBox="0 0 28 20"
    >
        <defs><path id="a" d="M0 0h28v20H0z" /></defs>
        <g fill="none" fill-rule="evenodd">
            <mask id="b" fill="#fff"><use xlink:href="#a" /></mask>
            <path
                stroke="#F5F5F5"
                stroke-width=".5"
                d="M.25.25h27.5v19.5H.25z"
            />
            <path fill="#E43D4C" d="M18.667 0H28v20h-9.333z" mask="url(#b)" />
            <path fill="#1BB65D" d="M0 0h9.333v20H0z" mask="url(#b)" />
        </g>
    </svg>
</template>
